import { useMemo } from "react"
import { isUS } from "src/utils"

// this wraps isUS in useMemo so that it re-evaluates when the country changes
export function useIsUS(countryISOCode: Parameters<typeof isUS>[0]): ReturnType<typeof isUS> {
  return useMemo(
    () => isUS(countryISOCode),
    [countryISOCode],
  )
}
